import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-12 font-titleFont flex gap-20"
    >
      <div className="w-full">
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">
            2024 - 2026
          </p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full min-h-[800px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Full Stack Developer"
            subTitle="MobileFirst Applications Pvt Ltd — (Dec 2024 – Jul 2026)"
            result="Remote, India"
            des={
              <>
                • Developed and maintained full-stack enterprise applications
                across fintech, legal-tech, and sports betting domains.
                <br />
                • Built multi-tenant database systems with strict data isolation
                using NestJS middleware and Prisma ORM.
                <br />
                • Developed real-time WebSocket systems achieving under 200ms
                latency for live data synchronization.
                <br />
                • Integrated third-party APIs including Sportradar, PayPal,
                Trustly, Mercoa, and AWS S3 in production environments.
                <br />
                • Participated in Agile/Scrum code reviews ensuring code
                quality, security standards, and best practices.
                <br />
                • Optimized REST API response times and database query
                performance achieving 20–25% improvement.
                <br />
                • Deployed and maintained applications on AWS EC2 with PM2,
                Nginx reverse proxy, and S3 storage.
              </>
            }
          />
          <ResumeCard
            title="Trainee Full Stack Developer"
            subTitle="MobileFirst Applications Pvt Ltd — (Apr 2024 – Nov 2024)"
            result="Remote, India"
            des={
              <>
                • Built responsive React.js frontends with Tailwind CSS focusing
                on reusable component architecture.
                <br />
                • Developed backend services with Node.js and NestJS,
                integrating third-party APIs under senior mentorship.
                <br />
                • Contributed to full-stack feature development across multiple
                production projects following SDLC processes.
                <br />
                • Promoted to Full Stack Developer within 8 months based on
                consistent delivery and technical growth.
              </>
            }
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
